/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BookTokenRouteRouteImport } from './routes/book/$token/route'
import { Route as CancelTokenRouteRouteImport } from './routes/cancel/$token/route'

const BookTokenRouteRoute = BookTokenRouteRouteImport.update({
  id: '/book/$token',
  path: '/book/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/book/$token/route.lazy').then((d) => d.Route),
)
const CancelTokenRouteRoute = CancelTokenRouteRouteImport.update({
  id: '/cancel/$token',
  path: '/cancel/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/cancel/$token/route.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/book/$token': typeof BookTokenRouteRoute
  '/cancel/$token': typeof CancelTokenRouteRoute
}
export interface FileRoutesByTo {
  '/book/$token': typeof BookTokenRouteRoute
  '/cancel/$token': typeof CancelTokenRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/book/$token': typeof BookTokenRouteRoute
  '/cancel/$token': typeof CancelTokenRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/book/$token' | '/cancel/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/book/$token' | '/cancel/$token'
  id: '__root__' | '/book/$token' | '/cancel/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  BookTokenRouteRoute: typeof BookTokenRouteRoute
  CancelTokenRouteRoute: typeof CancelTokenRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/book/$token': {
      id: '/book/$token'
      path: '/book/$token'
      fullPath: '/book/$token'
      preLoaderRoute: typeof BookTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cancel/$token': {
      id: '/cancel/$token'
      path: '/cancel/$token'
      fullPath: '/cancel/$token'
      preLoaderRoute: typeof CancelTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  BookTokenRouteRoute: BookTokenRouteRoute,
  CancelTokenRouteRoute: CancelTokenRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
